<template>
  <div class="login-bg">
    <button
      type="button"
      class="auth-home-btn"
      aria-label="Home"
      @click="$router.push('/home')"
    >
      <i class="fas fa-home" aria-hidden="true"></i>
    </button>
    <div
      class="login-cont container"
      style="height: 80vh;"
    >
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <button
            type="button"
            class="auth-logo"
            @click="$router.push('/home')"
          >
            <img
              src="/assets/12k-new.avif"
              alt="12K"
              class="auth-logo__img"
            >
          </button>
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div
            class="card-body px-2 d-flex mx-0 col-12 mx-auto"
            style="background: rgba(255, 255, 255, 0.98);border-radius: 16px;box-shadow: 0 8px 32px rgba(26, 46, 31, 0.12);backdrop-filter: blur(12px);-webkit-backdrop-filter: blur(12px);border: 1px solid rgba(13, 59, 26, 0.35);"
          >
            <div class="col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t('auth.fail_message') }}
                  </span>
                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.name }}</small>
                <div class="form-group mb-3">
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.username')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem;"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>

                <div class="form-group mb-3 pt-3">
                  <small class="text-dark">{{ errors.phone }}</small>
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">{{ $t('setting.phone')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem;"
                    type="text"
                    v-model="phone"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                  }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem;"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #0D3B1A;"
                      v-if="isShowPassword"
                      @click="showablePassword('password')"
                    ></i>
                    <i
                      v-if="!isShowPassword"
                      class="fas fa-eye-slash showable-password"
                      style="color: #0D3B1A;"
                      @click="showablePassword('password')"
                    ></i>
                  </div>
                </div>
                <small class="text-dark">{{ errors.confirm_password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.confirm_password')
                  }}</label>
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem;"
                      type="password"
                      ref="confirm_password"
                      v-model="confirm_password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #0D3B1A;"
                      v-if="isShowConfirmPassword"
                      @click="showablePassword('confirm_password')"
                    ></i>
                    <i
                      v-if="!isShowConfirmPassword"
                      class="fas fa-eye-slash showable-password"
                      style="color: #0D3B1A;"
                      @click="showablePassword('confirm_password')"
                    ></i>
                  </div>
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.referralCode }}</small>
                <div class="form-group pt-3">
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">
                    {{ $t('auth.referral_code') }}
                    <span class="auth-optional-label">({{ $t('auth.optional') }})</span>
                  </label>
                  <input
                    class="form-control pl-2 px-4"
                    style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem; text-transform: uppercase;"
                    type="text"
                    v-model="referralCode"
                    maxlength="32"
                    autocomplete="off"
                    :placeholder="$t('auth.referral_code_placeholder')"
                    @blur="validateReferralCode()"
                    @keyup.enter="loginWithPhone"
                  />
                  <p
                    v-if="referralStatus === 'valid' && referralName"
                    class="auth-referral-hint auth-referral-hint--valid mb-0 mt-2"
                  >
                    {{ $t('auth.referral_code_valid', { name: referralName }) }}
                  </p>
                  <p
                    v-else-if="isValidatingReferral"
                    class="auth-referral-hint mb-0 mt-2"
                  >
                    {{ $t('auth.referral_code_checking') }}
                  </p>
                </div>
                <div class="auth-secondary-row mt-4 mb-2">
                  <button
                    type="button"
                    class="btn my-0 auth-action-btn auth-action-btn--primary"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t('auth.sign_up') }}
                    </div>

                    <Loading
                      color="#0D3B1A"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
                <div class="col-12 d-flex my-1">
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(13, 59, 26, 0.45); height: 0;"
                  ></div>
                  <div
                    class="my-auto px-3"
                    style="color: #0D3B1A;"
                  >OR</div>
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(13, 59, 26, 0.45); height: 0;"
                  ></div>
                </div>
                <div class="text-center mb-3">
                  <button
                    type="button"
                    class="btn my-2 auth-action-btn auth-action-btn--secondary"
                    @click="$router.push('/auth/login')"
                  >
                    {{ $t('auth.login') }}
                  </button>
                </div>
                <!-- <div class="col-12 d-flex my-1">
                      <div class="col-5 p-0 my-auto divider-line"></div>
                      <div class="my-auto divider-text px-3">OR</div>
                      <div class="col-5 p-0 my-auto divider-line"></div>
                    </div>
                    <div class="text-center mb-3">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: #082612; color: white; border-radius: 20px; width: 10rem; box-shadow: none;"
                        @click="$router.push('/auth/login')"
                      >
                        <div>
                          {{$t('auth.login')}}
                        </div>
                      </button>
                    </div> -->
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #D32F2F; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>

              <div class="auth-contact-wrap">
                <p class="auth-contact__hint">
                  {{ $store.state.language === 'en' ? 'Need help?' : 'အကူအညီလိုပါသလား' }}
                </p>
                <div class="row auth-contact-row mx-0">
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile"
                      :href="loginViberHref"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--viber">
                        <i class="fab fa-viber"></i>
                      </span>
                      <span class="auth-contact__title">Viber</span>
                    </a>
                  </div>
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile auth-contact--telegram"
                      :href="telegramLink(loginTelegram)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--telegram">
                        <i class="fab fa-telegram-plane"></i>
                      </span>
                      <span class="auth-contact__title">{{ loginTelegramLabel }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions, mapMutations } from 'vuex';
import { viberLink, telegramLink } from '@/utils/contactLinks';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      referralCode: '',
      referralStatus: null,
      referralName: '',
      isValidatingReferral: false,
      error: false,
      errors: {},
      isSignin: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
      defaultTelegram: 'https://t.me/gameautosite_bot',
      defaultViber: 'https://msng.link/o?959451907249=vi',
    };
  },
  computed: {
    loginTelegram() {
      return this.$store.state.contactTelegram || this.defaultTelegram;
    },
    loginViberHref() {
      if (this.$store.state.contactInfo) {
        return viberLink(this.$store.state.contactInfo);
      }
      return this.defaultViber;
    },
    loginTelegramLabel() {
      const value = this.loginTelegram;
      if (String(value).startsWith('@')) {
        return value;
      }
      if (String(value).includes('t.me/')) {
        const handle = String(value).split('t.me/').pop().split(/[?#]/)[0];
        return handle ? `@${handle}` : 'Telegram';
      }
      return `@${value}`;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    ...mapMutations(['setContactInfo', 'setContactTelegram']),
    telegramLink,
    showablePassword(ref) {
      if (ref === 'password') {
        if (this.isShowPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowPassword = !this.isShowPassword;
      } else {
        if (this.isShowConfirmPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowConfirmPassword = !this.isShowConfirmPassword
      }
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    normalizedReferralCode() {
      return (this.referralCode || '').trim().toUpperCase();
    },
    syncReferralFromRoute() {
      const fromQuery = this.$route.query.code
        || this.$route.query.ref
        || this.$route.query.referral;
      const stored = localStorage.getItem('referralCode');
      const code = (fromQuery || stored || '').trim().toUpperCase();

      if (fromQuery) {
        localStorage.setItem('referralCode', code);
      }

      if (code) {
        this.referralCode = code;
        this.validateReferralCode();
      }
    },
    async validateReferralCode(showToast = false) {
      const code = this.normalizedReferralCode();
      if (!code) {
        this.referralStatus = null;
        this.referralName = '';
        this.errors.referralCode = '';
        localStorage.removeItem('referralCode');
        return true;
      }

      this.isValidatingReferral = true;
      try {
        const res = await this.axios.post('/streamers/validate-referral', {
          referral_code: code,
        });
        this.referralStatus = 'valid';
        this.referralName = res.data?.data?.streamer_name
          || res.data?.data?.referral_name
          || '';
        this.errors.referralCode = '';
        localStorage.setItem('referralCode', code);
        return true;
      } catch (err) {
        this.referralStatus = 'invalid';
        this.referralName = '';
        this.errors.referralCode = this.$t('auth.referral_code_invalid');
        if (showToast) {
          Toast.fail(this.errors.referralCode);
        }
        return false;
      } finally {
        this.isValidatingReferral = false;
      }
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Required User Name'
            : 'User name လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone =
          this.$store.state.language === 'en'
            ? 'Required Phone'
            : 'Phone လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Required Password'
            : 'Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Required Confirm Password'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Password not match!'
            : 'Password not match!';
        this.isSignin = false;
        return false;
      }
      if (this.normalizedReferralCode()) {
        const referralOk = await this.validateReferralCode(true);
        if (!referralOk) {
          this.isSignin = false;
          return false;
        }
      }
      try {
        const payload = {
          user_name: this.name,
          phone: this.phone,
          password: this.password,
          confirmPassword: this.confirm_password,
          roles: 'normal',
        };
        const code = this.normalizedReferralCode();
        if (code) {
          payload.referralCode = code;
        }

        const res = await this.axios.post(
          '/auth/register',
          payload,
        );
        localStorage.setItem('username', this.phone);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);
        localStorage.removeItem('referralCode');

        await this.fetchUser();
        this.$router.push('/auth/login');

        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
      } catch (err) {
        this.error = true;
        const message = err.response?.data?.error
          || err.response?.data?.message
          || this.$t('auth.fail_message');
        Toast.fail(message);
      }
      this.isSignin = false;
      return true;
    },
    async fetchWebsiteContact() {
      try {
        const res = await this.axios.get('/website-infos');
        const info = res.data.data[0];
        if (!info) return;
        this.setContactInfo(info.contact_info);
        this.setContactTelegram(
          info.telegram_info
            || info.contact_telegram
            || info.telegram
            || info.telegram_link
            || null
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.fetchWebsiteContact();
    this.syncReferralFromRoute();
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background: #0D3B1A;
  background-color: #0D3B1A;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-home-btn {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: #E8B923;
  color: #0D3B1A;
  font-size: 1.15rem;
  cursor: pointer;
}

.auth-home-btn:hover,
.auth-home-btn:focus {
  filter: brightness(1.06);
  outline: none;
}

.login-cont {
  margin-top: -10rem;
}

.auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto 1.25rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.auth-logo__img {
  display: block;
  height: 9.5rem;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.divider-line {
  border-top: 1px solid rgba(255, 255, 255, 0.6);
  height: 0;
}

.divider-text {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  color: #B71C1C;
  border: 1px solid rgba(211, 47, 47, 0.45);
  border-radius: 8px;
  padding: 0px 15px;
  background: #FFEBEE;
  font-weight: 700;
}

.auth-card {
  background: #eeecec;
  /* color: black */
}

.auth-action-btn {
  min-height: 36px !important;
  width: min(100%, 14rem);
  margin-left: auto;
  margin-right: auto;
  border-radius: 18px !important;
  border: none !important;
  outline: none !important;
  font-size: 0.9rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em;
  box-shadow: none !important;
}

.auth-action-btn--primary,
.btn.auth-action-btn--primary {
  background: #E8B923 !important;
  color: #0D3B1A !important;
}

.auth-action-btn--primary *,
.btn.auth-action-btn--primary * {
  color: #0D3B1A !important;
}

.auth-action-btn--secondary,
.btn.auth-action-btn--secondary {
  width: min(100%, 11rem);
  background: #0D3B1A !important;
  color: #FFFFFF !important;
}

.auth-action-btn--secondary *,
.btn.auth-action-btn--secondary * {
  color: #FFFFFF !important;
}

.auth-secondary-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
}

.auth-secondary-row .auth-action-btn--primary {
  margin: 0 !important;
  width: auto;
  min-width: 10rem;
}

.auth-contact-wrap {
  margin-top: 1.25rem;
  padding-top: 0.25rem;
}

.auth-contact__hint {
  margin: 0 0 0.65rem;
  text-align: center;
  color: #082612;
  font-size: 0.9rem;
  font-weight: 800;
}

.auth-contact-row {
  width: 100%;
}

.auth-contact-col {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.auth-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.65rem 0.35rem;
  border-radius: 12px;
  border: 1px solid rgba(13, 59, 26, 0.35);
  background: #F5F7F5;
  text-decoration: none;
  text-align: center;
  flex-direction: column;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.auth-contact:active {
  background: #E5EBE6;
  border-color: rgba(13, 59, 26, 0.55);
  text-decoration: none;
}

.auth-contact__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.25rem;
}

.auth-contact__icon--viber {
  background: #7360f2;
  color: #ffffff;
}

.auth-contact__icon--telegram {
  background: #229ed9;
  color: #ffffff;
}

.auth-contact__title {
  color: #082612;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.25;
  word-break: break-word;
}

.auth-optional-label {
  font-size: 0.78rem;
  font-weight: 500;
  color: #6B7F70;
}

.auth-referral-hint {
  font-size: 0.78rem;
  color: #6B7F70;
}

.auth-referral-hint--valid {
  color: #1B6B2E;
  font-weight: 600;
}
</style>
